import OldFooter from '@/website/components/Footer';

export default function Footer() {
  return <OldFooter />;
}
